import React from 'react'
import { Text } from 'components/library'
import './BreakLine.css'


const BreakLine = props => (

  <div className="Break-line">

    {props.title &&
      <div className="has-title">
        <hr />
        <Text>{props.title}</Text>
        <hr />
      </div>
    }


    {props.line &&
      <div className="has-line">
        <hr />
      </div>
    }

  </div>
)

export default BreakLine



// WEBPACK FOOTER //
// ./src/components/library/breakline/BreakLine.js